import extend from 'dva-model-extend';

export const isPlainObject = (o) => Object.prototype.toString.call(o) === '[object Object]';

export const extendModel = (models, model) => {
  if (Array.isArray(models)) {
    const target = models.find((m) => m.namespace === model.namespace);
    if (target) {
      return extend(model, target);
    }
  }

  return model;
};
